import { useMemo } from 'react'
import { formatShortCurrency } from 'data/helpers/currency'
import { AvailabilityQuery, PropertyPageQuery } from 'gql/graphql'
import BookingConditionsMobileItem, { BookingConditionsMobileItemProps } from 'components/property/booking-conditions/BookingConditionsMobileItem'
import { getAllocatedAmountFromRatios } from 'data/helpers/allocation'

const BookingConditionsMobile = ({
  property,
  availability,
}: {
  property: NonNullable<PropertyPageQuery['property']>
  availability: AvailabilityQuery['availability']
}) => {
  const bookingConditionsItems: BookingConditionsMobileItemProps[] = useMemo(() => {
    let conditionItems: BookingConditionsMobileItemProps[] = []

    const RentalDepositDescription = 'Due upon booking'
    const BalanceOfRentalDescription = `Due ${property.property_rental_due?.value} days prior to arrival`

    if (availability?.price) {
      const ratios = [50, 50]
      const [price1, price2] = getAllocatedAmountFromRatios(availability.price, ratios)

      conditionItems = [
        {
          header: 'RENTAL DEPOSIT (50%)',
          description: RentalDepositDescription,
          pill: formatShortCurrency(price1, availability?.currency),
        },
        {
          header: 'BALANCE OF RENTAL (50%)',
          description: BalanceOfRentalDescription,
          pill: formatShortCurrency(price2, availability?.currency),
        },
      ]
    } else {
      conditionItems = [
        {
          header: 'RENTAL DEPOSIT',
          description: RentalDepositDescription,
          pill: '50%',
        },
        {
          header: 'BALANCE OF RENTAL',
          description: BalanceOfRentalDescription,
          pill: '50%',
        },
      ]
    }

    const included = ([
      ...(property?.linen_towels_services ?? []),
      ...(property?.housekeeping_services ?? []),
      ...(property?.staff_services ?? []),
      ...(property?.other_services ?? []),
    ])

    return [
      ...conditionItems,
      {
        header: 'REFUNDABLE DAMAGE DEPOSIT',
        description: `Due ${property.property_rental_due?.value} days prior to arrival`,
        pill: formatShortCurrency((property?.security_deposit?.value ?? 0) * 100, property?.currency),
      },
      {
        header: 'CANCELLATION POLICY',
        description: 'Each payment is non-refundable',
        pill: 'Strict',
      },
      {
        header: 'INCLUDED SERVICES',
        description: included.map(service => service.value) ?? [],
        showCheckbox: true,
      },
      {
        header: 'ADDITIONAL CONDITIONS',
        description: [
          ...(property?.additional_costs?.map(cost => cost.value) ?? []),
          property?.extra_additional_costs,
          ...(property?.house_rules?.map(rule => rule.value) ?? []),
          property?.additional_house_rules,
        ].filter(Boolean) ?? [],
      },
    ]
  }, [property, availability?.price, availability?.currency])

  return (
    <>
      {
        bookingConditionsItems.map((item, index) => (
          <>
            {index !== 0 && (
              <hr className="h-2 mt-20 mb-24 border-none bg-grey-150" />
            )}

            <BookingConditionsMobileItem key={index} {...item} />
          </>
        ))
      }
    </>
  )
}
export default BookingConditionsMobile
